/* i18n */
if(typeof window!=="undefined"&&typeof window.TR==="undefined"){window.TR=function(k,v){if(window.GS&&GS.t)return GS.t(k,v);if(window.GSUX_LANG&&window.GSUX_LANG[k]!=null)return window.GSUX_LANG[k];return k;};}
var TR=window.TR;
/* heatmaps/assets/js/heatmap.js — canvas heatmap renderer + viewer controller (screenshot + grid).
 * Composites an interaction-heat overlay on top of the page screenshot captured by the tracker,
 * replacing the old iframe preview (which CSP/X-Frame-Options blocked on most sites). Reads the grid
 * from /plugin/heatmaps/render and the screenshot from /plugin/heatmaps/shot. Uses window.GS.api.
 * Expects the DOM emitted by frontend/pages.php (data-hm="…" hooks). */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["heatmaps"] = "2.1.2"; } catch (e) {}

  // ---- colour lookup table (blue -> cyan -> green -> yellow -> red) ----
  var STOPS = [[0, 40, 90, 220], [0.35, 30, 170, 120], [0.6, 240, 210, 40], [0.8, 240, 140, 30], [1, 220, 40, 40]];
  var LUT = (function () {
    var t = [];
    for (var i = 0; i < 256; i++) {
      var p = i / 255, a = STOPS[0], b = STOPS[STOPS.length - 1];
      for (var s = 0; s < STOPS.length - 1; s++) if (p >= STOPS[s][0] && p <= STOPS[s + 1][0]) { a = STOPS[s]; b = STOPS[s + 1]; break; }
      var f = (b[0] - a[0]) ? (p - a[0]) / (b[0] - a[0]) : 0;
      t.push([Math.round(a[1] + (b[1] - a[1]) * f), Math.round(a[2] + (b[2] - a[2]) * f), Math.round(a[3] + (b[3] - a[3]) * f)]);
    }
    return t;
  })();

  // Click/move: gaussian blobs at cell centres, then colourised via the LUT. cells are {x,y,w} grid coords.
  function drawGrid(canvas, cells, max, gx, gy, o) {
    var ctx = canvas.getContext("2d"), W = canvas.width, H = canvas.height;
    ctx.clearRect(0, 0, W, H);
    if (!cells || !cells.length) return;
    var cw = W / gx, ch = H / gy, r = Math.max(cw, ch) * 2.2;   // overlap for a smooth field
    var off = document.createElement("canvas"); off.width = W; off.height = H;
    var oc = off.getContext("2d");
    cells.forEach(function (c) {
      var a = Math.min(1, (c.w / (max || 1)) * o.intensity);
      if (a <= 0) return;
      var x = (c.x + 0.5) * cw, y = (c.y + 0.5) * ch;
      var g = oc.createRadialGradient(x, y, 0, x, y, r);
      g.addColorStop(0, "rgba(0,0,0," + a + ")"); g.addColorStop(1, "rgba(0,0,0,0)");
      oc.fillStyle = g; oc.beginPath(); oc.arc(x, y, r, 0, 6.2832); oc.fill();
    });
    var img = oc.getImageData(0, 0, W, H), d = img.data;
    for (var i = 0; i < d.length; i += 4) {
      var al = d[i + 3];
      if (al) { var col = LUT[al]; d[i] = col[0]; d[i + 1] = col[1]; d[i + 2] = col[2]; d[i + 3] = Math.round(al * o.opacity); }
    }
    oc.putImageData(img, 0, 0);
    ctx.drawImage(off, 0, 0);
  }

  // Scroll: each cell is a session whose deepest scroll landed in row y. Draw cumulative reach bands —
  // the fraction of sessions that reached at least depth y — so you see where the page loses people.
  function drawScrollGrid(canvas, cells, gy, o) {
    var ctx = canvas.getContext("2d"), W = canvas.width, H = canvas.height;
    ctx.clearRect(0, 0, W, H);
    if (!cells || !cells.length) return;
    var depth = new Array(gy).fill(0), total = 0;
    cells.forEach(function (c) { var yy = Math.min(gy - 1, Math.max(0, c.y | 0)); depth[yy] += c.w; total += c.w; });
    if (!total) return;
    var reach = new Array(gy).fill(0), acc = 0;
    for (var y = gy - 1; y >= 0; y--) { acc += depth[y]; reach[y] = acc / total; }
    var ch = H / gy, fontPx = Math.max(10, Math.round(W / 90));
    for (var yy = 0; yy < gy; yy++) {
      var col = LUT[Math.round(reach[yy] * 255)];
      ctx.fillStyle = "rgba(" + col[0] + "," + col[1] + "," + col[2] + "," + (0.5 * o.opacity) + ")";
      ctx.fillRect(0, yy * ch, W, ch + 1);
    }
    ctx.fillStyle = "rgba(20,25,35,0.9)"; ctx.font = fontPx + "px 'Open Sans',system-ui";
    for (var p = 10; p < 100; p += 10) {
      var yb = Math.min(gy - 1, Math.round((p / 100) * gy));
      ctx.fillText(Math.round(reach[yb] * 100) + "% reach", 8, yb * ch - 3);
    }
  }

  function ctl() {
    var d = document;
    return {
      page: d.querySelector('[data-hm="page"]'),
      rangeBtn: d.querySelector('[data-hm="rangeBtn"]'),
      rangeMenu: d.querySelector('[data-hm="rangeMenu"]'),
      rangeLabel: d.querySelector('[data-hm="range-label"]'),
      opacity: d.querySelector('[data-hm="opacity"]'),
      intensity: d.querySelector('[data-hm="intensity"]'),
      canvas: d.querySelector('[data-hm="canvas"]'),
      shot: d.querySelector('[data-hm="shot"]'),
      noshot: d.querySelector('[data-hm="noshot"]'),
      stage: d.querySelector('[data-hm="stage"]'),
      empty: d.querySelector('[data-hm="empty"]'),
      reclink: d.querySelector('[data-hm="reclink"]'),
      layerBtns: d.querySelectorAll("[data-hm-layer]"),
      deviceBtns: d.querySelectorAll("[data-hm-device]")
    };
  }

  function init(root) {
    if (!root || root._hmWired || !window.GS || !GS.api) return;
    // No site resolved (account has none, or /sites failed): say so instead of firing every
    // request with an empty site= and filling the console with 404s.
    if (!GS.site) { root.innerHTML = '<div class="gs-muted" style="padding:28px;text-align:center">'+TR('heatma.no_site_selected_yet_add_or_choose_a_site_to')+'</div>'; return; }
    root._hmWired = 1;
    var c = ctl(), layer = "click", device = "desktop", lastGrid = null, shotCache = {};
    if (!c.page || !c.canvas) return;

    /* Date range — normalised to the shared devicedetector picker (presets + custom range). */
    function T(k, v) { return (window.GS && GS.t) ? GS.t(k, v) : k; }
    function _ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
    function _today() { var n = new Date(); return new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate())); }
    function preset(days) { var to = _today(), from = new Date(to.getTime() - (days - 1) * 86400000); var lbl = { 7: T("an.last7"), 30: T("an.last30"), 90: T("an.last90"), 365: T("an.last12mo") }[days] || (days + " days"); return { from: _ymd(from), to: _ymd(to), label: lbl, preset: String(days) }; }
    var RANGE = (function () { try { var s = JSON.parse(localStorage.getItem("gs_hm_range") || "null"); if (s && s.preset) return preset(+s.preset); if (s && s.from && s.to) return s; } catch (e) {} return preset(30); })();
    function saveRange() { try { localStorage.setItem("gs_hm_range", JSON.stringify(RANGE)); } catch (e) {} }
    (function initRange() {
      var btn = c.rangeBtn, menu = c.rangeMenu, lab = c.rangeLabel; if (!btn || !menu) return;
      if (lab && RANGE.label) lab.textContent = RANGE.label;
      function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === RANGE.preset); }); }
      btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); var open = menu.style.display !== "none"; menu.style.display = open ? "none" : "block"; if (!open) { var cf = menu.querySelector('[data-rp="from"]'), ct = menu.querySelector('[data-rp="to"]'); if (cf) cf.value = RANGE.from; if (ct) ct.value = RANGE.to; sync(); } });
      document.addEventListener("click", function (e) { if (!btn.contains(e.target)) menu.style.display = "none"; });
      function apply(r) { RANGE = r; if (lab) lab.textContent = RANGE.label; saveRange(); menu.style.display = "none"; loadGrid(); }
      menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { apply(preset(+b.getAttribute("data-preset"))); }); });
      var ap = menu.querySelector('[data-rp="apply"]'); if (ap) ap.addEventListener("click", function () { var ff = menu.querySelector('[data-rp="from"]').value, tt = menu.querySelector('[data-rp="to"]').value; if (!ff || !tt) return; if (ff > tt) { var x = ff; ff = tt; tt = x; } apply({ from: ff, to: tt, label: ff + " \u2192 " + tt, preset: null }); });
    })();

    function sizeCanvas() {
      var W = c.stage.clientWidth || 1, dpr = Math.min(2, window.devicePixelRatio || 1), img = c.shot, H;
      if (img && !img.hidden && img.naturalWidth) { H = Math.round(W * img.naturalHeight / img.naturalWidth); c.stage.style.height = ""; }
      else { H = Math.round(W * (device === "mobile" ? 1.8 : 0.9)); c.stage.style.height = H + "px"; }
      c.canvas.width = Math.max(1, Math.round(W * dpr));
      c.canvas.height = Math.max(1, Math.round(H * dpr));
    }

    function draw() {
      sizeCanvas();
      var o = { opacity: (+c.opacity.value || 80) / 100, intensity: (+c.intensity.value || 60) / 100 };
      var d = lastGrid, has = d && d.cells && d.cells.length;
      if (!d) { if (c.empty) c.empty.style.display = ""; c.canvas.getContext("2d").clearRect(0, 0, c.canvas.width, c.canvas.height); return; }
      if (layer === "scroll") drawScrollGrid(c.canvas, d.cells, d.gy || 100, o);
      else drawGrid(c.canvas, d.cells, d.max, d.gx || 50, d.gy || 100, o);
      if (c.empty) c.empty.style.display = has ? "none" : "";
    }

    function applyShot(dataUrl) {
      if (dataUrl) {
        c.noshot.hidden = true;
        c.shot.onload = function () { sizeCanvas(); draw(); };
        c.shot.src = dataUrl; c.shot.hidden = false;
      } else {
        c.shot.hidden = true; c.shot.removeAttribute("src"); c.noshot.hidden = false;
        sizeCanvas(); draw();
      }
    }

    async function loadShot() {
      var page = c.page.value || "/", key = page + "|" + device;
      if (key in shotCache) { applyShot(shotCache[key]); return; }
      var r = await GS.api("/plugin/heatmaps/shot?page=" + encodeURIComponent(page) + "&device=" + device + "&site=" + encodeURIComponent(GS.site || ""));
      var img = (r.ok && r.data && r.data.img) || null;
      shotCache[key] = img; applyShot(img);
    }

    async function loadGrid() {
      var page = c.page.value || "/";
      var q = "/plugin/heatmaps/render?page=" + encodeURIComponent(page) + "&device=" + device + "&layer=" + layer +
              "&from=" + RANGE.from + "&to=" + RANGE.to + "&site=" + encodeURIComponent(GS.site || "");
      var r = await GS.api(q); lastGrid = (r.ok && r.data) || null; draw();
    }

    // Cross-link to Session Recording: how many recordings exist for this page (and how many are
    // frustration-triggered). Fails silent if the plugin isn't installed/enabled for this user.
    function loadRecLink() {
      var a = c.reclink; if (!a) return;
      a.hidden = true;
      var page = c.page.value || "/";
      GS.api("/plugin/session-recordings/list?site=" + encodeURIComponent(GS.site || "") + "&page=" + encodeURIComponent(page) + "&limit=1")
        .then(function (r) {
          var d = (r.ok && r.data) || null, total = d ? (+d.total || 0) : 0, fr = d ? (+d.frustration || 0) : 0;
          if (!total) return;
          a.href = "/session-recordings?page=" + encodeURIComponent(page);
          a.innerHTML = '<i class="bi bi-play-circle-fill"></i> Watch ' + total + ' recording' + (total === 1 ? "" : "s") + " of this page" +
                        (fr > 0 ? ' <span class="hm-rec-fr">' + fr + " frustrated</span>" : "");
          a.hidden = false;
        })["catch"](function () {});
    }

    // When nothing has been captured, replace the generic banner text with the ACTUAL reason from the
    // site's effective data-limits (off / 0% sampling / capped / just no sampled visit yet).
    function siteNumId() { var a = (GS.sites || []); var s = a.filter(function (x) { return x.public_key === GS.site; })[0] || a[0]; return s ? s.id : 0; }
    function emptyReason(cl, noun) {
      var on = cl && cl.hm;
      if (!cl) return "Give the page some traffic, and make sure your tracking snippet is current under <a href=\"/site-settings\">Site settings &rarr; Tracking</a>.";
      if (!on) return "Heatmap capture is off for this site on your current plan/limits. Turn up sampling under <a href=\"/site-settings\">Site settings &rarr; Data limits</a>, or upgrade your plan.";
      if ((cl.sample || 0) <= 0) return "Sampling is set to <strong>0%</strong> for this site, so no " + noun + "s are captured. Raise it under <a href=\"/site-settings\">Site settings &rarr; Data limits</a>.";
      return "Sampling is on (<strong>" + cl.sample + "%</strong>)" + (cl.capped ? ", but the storage/daily cap is reached" : "") + ", but no " + noun + " has been captured yet. Regenerate your tracking snippet under <a href=\"/site-settings\">Site settings &rarr; Tracking</a> and give the page some traffic.";
    }
    function explainInstall(inst) {
      var sid = siteNumId(); if (!sid) return;
      GS.api("/sites/data-limits?site_id=" + sid).then(function (r) {
        var cl = (r.ok && r.data && r.data.client) || null, m = inst.querySelector(".gs-muted.small");
        if (m) m.innerHTML = emptyReason(cl, "heatmap");
      })["catch"](function () {});
    }

    async function loadPages() {
      var r = await GS.api("/plugin/heatmaps/pages?site=" + encodeURIComponent(GS.site || ""));
      var pages = (r.ok && r.data && r.data.pages) || [];
      var inst = document.querySelector('[data-hm="install"]');
      if (inst) { inst.hidden = pages.length > 0; if (!pages.length) explainInstall(inst); }
      c.page.innerHTML = pages.length
        ? pages.map(function (p) { return '<option value="' + p.page_url + '">' + p.page_url + " (" + p.samples + ")</option>"; }).join("")
        : '<option value="">'+TT('heat.js.no_pages_captured_yet')+'</option>';
      gsDeep(pages);
      loadShot(); loadGrid(); loadRecLink();
    }

    /* Deep link: /heatmaps?page=<url>&layer=click|move|scroll&device=desktop|tablet|mobile */
    var _deepDone = false;
    function gsDeep(pages) {
      if (_deepDone) return; _deepDone = true;
      var d = { page: null, layer: null, device: null };
      if (window.GSLink) d = window.GSLink.read({ page: "text512", layer: "slug", device: "slug" });
      else {
        try {
          var qp = new URLSearchParams(location.search);
          d.page = (String(qp.get("page") || "").trim().slice(0, 512)) || null;
          d.layer = (String(qp.get("layer") || "").toLowerCase().replace(/[^a-z]/g, "")) || null;
          d.device = (String(qp.get("device") || "").toLowerCase().replace(/[^a-z]/g, "")) || null;
        } catch (e) {}
      }
      if (d.page && (pages || []).some(function (p) { return p.page_url === d.page; })) c.page.value = d.page;
      if (d.device) { var dv = document.querySelector('[data-hm-device="' + d.device + '"]'); if (dv) { device = d.device; c.deviceBtns.forEach(function (x) { x.classList.toggle("on", x === dv); }); } }
      if (d.layer) { var lb = document.querySelector('[data-hm-layer="' + d.layer + '"]'); if (lb) { layer = d.layer; c.layerBtns.forEach(function (x) { x.classList.toggle("on", x === lb); }); } }
    }
    function gsWrite() {
      if (!window.GSLink || !c.page) return;
      window.GSLink.write({ page: c.page.value || null, layer: layer, device: device });
    }

    c.page.addEventListener("change", function () { gsWrite(); loadShot(); loadGrid(); loadRecLink(); });
    /* range reload handled by the picker (initRange -> apply -> loadGrid) */
    [c.opacity, c.intensity].forEach(function (el) { el && el.addEventListener("input", draw); });
    c.layerBtns.forEach(function (b) { b.addEventListener("click", function () {
      layer = b.getAttribute("data-hm-layer");
      c.layerBtns.forEach(function (x) { x.classList.toggle("on", x === b); }); gsWrite(); loadGrid();
    }); });
    c.deviceBtns.forEach(function (b) { b.addEventListener("click", function () {
      device = b.getAttribute("data-hm-device");
      c.deviceBtns.forEach(function (x) { x.classList.toggle("on", x === b); }); gsWrite(); loadShot(); loadGrid(); loadRecLink();
    }); });
    window.addEventListener("resize", function () { clearTimeout(root._hmT); root._hmT = setTimeout(draw, 200); });

    loadPages();
  }

  /* Boot ONCE, and only after main.js has resolved GS.site.
     Booting on DOMContentLoaded raced that resolution: every request went out as `site=` and
     404'd, then gs:ready booted everything a second time. One boot, one set of requests. */
  var _booted = false;
  function boot() { if (_booted) return; _booted = true; document.querySelectorAll('[data-hm="root"]').forEach(init); }
  document.addEventListener("gs:ready", boot, { once: true });
  if (window.GS && GS.site) boot();          // gs:ready already fired before this script loaded
})();
